import React from 'react';

const FilterContext = React.createContext({
    caseListFilters: {},
    setCaseListFilters: (filterName, value) => { },
});

export default FilterContext;